require('./insuranceRequestWizardGuide.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');

// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const { formatAmount } = require('utilities/currencyHelper');

// @ commons
const { OKButton } = require('components/commons/OKButton/OKButton');
const { ModalCustom } = require('commonsComponents/modalCustom');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');

// @ constants
const { EURO_SYMBOL } = require('constants/index');
const { texts } = require('../../../insuranceConstants/insuranceRequestGuide');

class InsuranceRequestWizardGuide extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showModal: false
        };

        this.handleToggleModal = this.handleToggleModal.bind(this);
        this.handleSelectPlanModal = this.handleSelectPlanModal.bind(this);
        this.buildPlan = this.buildPlan.bind(this);
        this.buildPlans = this.buildPlans.bind(this);
    }

    handleToggleModal() {
        if (!this.state.showModal) {
            this.props.onHandleToggleModal();
        }

        this.setState(previousState => {
            return {
                showModal: !previousState.showModal
            }
        });
    }

    handleSelectPlanModal(evt, planIdx) {
        evt && evt.preventDefault();

        this.props.onSelectPlanModal(planIdx);
        this.handleToggleModal();
    }

    buildPlan(plan, planIdx = 0) {

        const ICONS = [
            ['icon-casa-busqueda'],
            ['icon-casa-busqueda', 'insurance-request-wizard-guide__modal-icon-plus', 'icon-bicicleta', 'icon-imagen'],
            ['icon-casa-busqueda', 'insurance-request-wizard-guide__modal-icon-plus', 'icon-bicicleta', 'icon-imagen', 'icon-laptop']
        ];

        const buildIcons = planIdx => {
            const icons = ICONS[planIdx].map((iconClass, idx) => {
                let elClass = classNames(iconClass, 'insurance-request-wizard-guide__modal-icon');

                if (iconClass === 'icon-bicicleta') {
                    elClass = classNames(iconClass, 'insurance-request-wizard-guide__modal-icon', 'insurance-request-wizard-guide__modal-bicycle-icon');
                }

                return <i key={idx} className={elClass}></i>;
            });

            return (
                <div className="insurance-request-wizard-guide__modal-plan-icon-group">
                    {icons}
                </div>
            );
        };

        const listItems = texts()[planIdx].map((text, idx) => {
            return (
                <li key={idx} className="insurance-request-wizard-guide__modal-plan-list-item">
                    <span className="insurance-request-wizard-guide__modal-plan-list-text">
                        {text}
                    </span>
                </li>
            );
        });

        return (
            <div key={planIdx} className="col-sm-4 insurance-request-wizard-guide__modal-plan">
                <div className="insurance-request-wizard-guide__modal-plan-content">
                    <h3 className="insurance-request-wizard-guide__modal-plan-title">
                        {formatText(`insuranceRequestHome-step2GuidePropertyType${[planIdx + 1]}`)}
                    </h3>
                    {buildIcons(planIdx)}
                    <div className="insurance-request-wizard-guide__modal-plan-subtitle">
                        <span className="insurance-request-wizard-guide__modal-plan-subtitle-text">
                            {formatText(`insuranceRequestHome-step2GuidePropertySubtitleType${[planIdx + 1]}`)}
                        </span>
                    </div>
                    <ul className="insurance-request-wizard-guide__modal-plan-list">
                        {listItems}
                    </ul>
                </div >
                <div className="insurance-request-wizard-guide__modal-plan-footer">
                    <div className="insurance-request-wizard-guide__modal-plan-footer-text">
                        {formatText('insuranceRequestHome-step2GuideTextContent')}
                        <span className="insurance-request-wizard-guide__modal-plan-footer-price">
                            {formatAmount(plan.content, undefined, 0)} {EURO_SYMBOL}
                        </span>
                    </div>
                    <OKButton
                        customLinkClassName="insurance-request-wizard-guide__modal-plan-footer-btn"
                        modifier="primary"
                        size="regular"
                        onClick={evt => this.handleSelectPlanModal(evt, planIdx)}
                    >
                        {formatText('insuranceRequestHome-step2GuideButton')}
                    </OKButton>
                </div>
            </div >
        );
    }

    buildPlans(recommendations) {
        return recommendations.map((plan, planId) => this.buildPlan(plan, planId));
    }

    buildModal() {
        const {
            recommendationsData,
            isRelated,
            showGuideModal
        } = this.props;

        const step2GuideTitle = formatText('insuranceRequestHome-step2GuideTitle');
        const step2GuideSubtitleTitle = isRelated ? 'insuranceRelatedRequest-step2GuideSubtitle' : 'insuranceRequestHome-step2GuideSubtitle';

        const recommendations = this.buildPlans(recommendationsData);

        return (
            <ModalCustom
                extraClass="insurance-request-wizard-guide__modal"
                isOpen={showGuideModal && this.state.showModal}
                onRequestClose={this.handleToggleModal}
            >
                <section className="insurance-request-wizard-guide__modal-section">
                    <OKBoxTitle value={step2GuideTitle} />
                    <div className="insurance-request-wizard-guide__modal-subtitle">
                        <FormattedText value={step2GuideSubtitleTitle} />
                    </div>
                    <div className="row hidden-xs insurance-request-wizard-guide__modal-plans-wrapper">
                        {recommendations}
                    </div>
                </section>
            </ModalCustom>
        );
    }

    render() {

        const { showGuideText, isRelated } = this.props;

        if (!showGuideText) {
            return null;
        }

        const stepTwoHelpText = isRelated ? 'insuranceRelatedRequest-step2HelpText' : 'insuranceRequestHome-step2HelpText';

        return (
            <React.Fragment>
                <div className="row">
                    <div className="col-xs-12 insurance-request-wizard-step-two__help-text">
                        <FormattedText value={stepTwoHelpText} />
                        <OKButton
                            onClick={this.handleToggleModal}
                            modifier="link-emphasize"
                            autoHeight={true}
                            size="small"
                            id={'insurance-wizard-guide-toggle-modal-button'}
                        >
                            <FormattedText value="insuranceRequestHome-step2OurGuide" />
                        </OKButton>
                    </div>
                </div>
                {this.buildModal()}
            </React.Fragment>
        );
    }
}

InsuranceRequestWizardGuide.propTypes = {
    showGuideModal: PropTypes.bool.isRequired,
    showGuideText: PropTypes.bool.isRequired,
    isRelated: PropTypes.bool,
    onHandleToggleModal: PropTypes.func,
    onSelectPlanModal: PropTypes.func.isRequired,
    recommendationsData: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array,
    ])
};

InsuranceRequestWizardGuide.defaultProps = {
    onHandleToggleModal: () => { },
    isRelated: false
};

module.exports = InsuranceRequestWizardGuide;
